import styled from 'styled-components';

export const DetailWindow = styled.div`
    position: fixed;
    top: -100%;
    left: -100%;
    width: 450px;
    overflow: hidden;
    transform: translate3d(-50%, -50%, 0);
    border: 1px solid #999;
    background-color: #222;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    z-index: 1002;

    &.opened {
        top: 50%;
        left: 50%;
    }
`;

export const DetailBackground = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    bottom: 100%;
    right: 100%;
    background-color: rgba(0,0,0,0.4);
    z-index: 1001;

    &.opened {
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }
`;

export const DetailLabel = styled.div`
    color: #999;
    font-size: 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    text-transform: uppercase;
`;

export const DetailInput = styled.input`
    border: 0;
    border-bottom: 1px solid #999;
    color: #fff;
    background-color: #222;
    width: 100%;
    padding: 0 5px;
    box-sizing: border-box;
    margin: 1px 1px 20px 1px;
    height: 30px;

    &:focus {
        outline: none;
    }
`;

export const DetailTextarea = styled.textarea`
    height: 170px;
    border: 0;
    border-bottom: 1px solid #999;
    color: #fff;
    background-color: transparent;
    width: 100%;
    padding: 5px;
    box-sizing: border-box;
    resize: none;
    margin: 1px 1px 20px 1px;

    &:focus {
        outline: none;
    }
`;

export const DetailButton = styled.div`
    border: 1px solid ${props => props.color || props.theme.colors.main};
    height: 25px;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: all .4s ease 0s;
    cursor: pointer;
    width: 50px;
    position: relative;
    transition: all .3s ease 0s;

    &:hover:before {
        color: #fff;
        background-color: ${props => props.color || props.theme.colors.main};
    }

    &:before {
        color: ${props => props.color || props.theme.colors.main};
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        content: '${props => props.icon}';
        font-family: "Material Design Icons";
        transition: all .3s ease 0s;
    }
`;